import { render, staticRenderFns } from "./SPagination.vue?vue&type=template&id=150d9b88&scoped=true"
import script from "./sPagination.ts?vue&type=script&lang=ts&external"
export * from "./sPagination.ts?vue&type=script&lang=ts&external"
import style0 from "./SPagination.vue?vue&type=style&index=0&id=150d9b88&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150d9b88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150d9b88')) {
      api.createRecord('150d9b88', component.options)
    } else {
      api.reload('150d9b88', component.options)
    }
    module.hot.accept("./SPagination.vue?vue&type=template&id=150d9b88&scoped=true", function () {
      api.rerender('150d9b88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-pagination/SPagination.vue"
export default component.exports